export enum CheckPaymentType {
  PrintOnly = "PRINT_ONLY",
  PrintAndDeliver = "PRINT_AND_DELIVER",
}
